function initC(){
  $('#section-header').addClass('header--isscrolled');
  $('#section-header').addClass('smallever');

  $('.config_overlay .loader').children().remove();

  var loader = $('<div class="loaderinner_k"></div>');
  var image = $('<img src="//weidlor-shop.shop/cdn/shop/t/3/assets/penoblo-logo_weiss-animation.gif?v=7963">');
  var text = $('<h1>Passende Schreibgeräte werden gesucht    </h1>');

  loader.append( image );
  loader.append( text );
  $('.config_overlay .loader').append(loader);

  if ( isMobile ){
    $('#shopify-section-header').hide();
    $('#section-announcement').hide();
    $('#shopify-section-footer').hide();

  }
  $('body').addClass('configurator--ready');
}

$( document ).ready(function() {
  
  
  

  if( $('.config_overlay_result_headline').length == 1 ){
    initC();    
  }

  $(document).on('eventConfiguratorReady', function(){
     initC(); 
     
  });

 $(document).on('eventAddToCart', function(e){
    console.log('eventListener eventAddToCart');
	 window.location.href='/cart';
  	//$('[data-drawer-id="sidebar-cart"]').trigger('click');
  });


  $(document).on('eventResultsReady', function(e){
    
    
    $('.cf_buybutton').each( function(){
      
      $(this).find('h2 img').remove();
      
      if ( $(this).hasClass('sold') ){
        $(this).attr('class','ProductForm__AddToCart Button Button--primary Button--full cf_buybutton sold');
      } else {
        $(this).attr('class','ProductForm__AddToCart Button Button--primary Button--full cf_buybutton');
        $(this).find('h2').append('<img src="//weidlor-shop.shop/cdn/shop/t/3/assets/icon-shopping-bag.png?v=37934353444111832341608273679" class="add-to-cart-btn-icon">');
      }
      
      
      
      
    });
    
    $('.single_product:not(.template) .matching').each( function(){
      
      if ( isMobile ){
      	$(this).html( $(this).html().replace('.',',')+'%' );
      } else {
        $(this).html( $(this).html().replace('.',',') );
      }
      
    });
    
    $('.result_inner .single_product:not(.template) .single_product_inner>h2').each( function(){
      
      
      var s = $(this).parents('.single_product');
      
      var content = $(this).html().split(',');      
      var vendor = $(this).parent().parent().attr('data-vendor').toString().trim().toLowerCase();
      var vendorlogo = '//weidlor-shop.shop/cdn/shop/t/3/assets/testtesttest.png?v=7963';
      vendor = vendor.toLowerCase().replace(/ /g, '_' );
      vendor = vendor.toLowerCase().replace(/'/g, '' );
      vendorlogo = vendorlogo.replace('testtesttest.png', vendor+'.png' );
      
      var priceString = s.data('price')+' '+s.data('currency');
      
      $('<div class="vendorlogo" style="background-image: url('+vendorlogo+')"></div>').insertBefore( $(this) );
      
      
      
      $(this).html( content[1]+content[2] );
      $(this).append( $('<p class="mobile_price_h2"></p>').html( priceString ) );
      
      
    });
    
    
    if ( isMobile ){
      
      
      $('.config_overlay_result_headline .results_found .fa-heart').remove();
      $('.config_overlay_result_headline .results_found img').remove();
      var img = $('<img src="">');
      img.attr('src', '//weidlor-shop.shop/cdn/shop/t/3/assets/001-confetti.png?v=109646390281406928391608273573' );
               
      $('.config_overlay_result_headline .results_found').append( img );;
        
    }
    
    $('.result_inner .single_product:not(.template) .single_product_inner').each( function(){
       
      if ( isMobile ){
        
        var url = $(this).find('.single_product_image').data('img');
        
        $(this).find('.single_product_image').append('<img class="rawImg" src="'+url+'">');
        

        var p = $(this).find('.single_product_hover p');
        p.addClass('mobile_hover_p');
        $(this).append(p);
        
        $(this).css('min-height','auto');
       
      }
      
    });
    
    $('.config_results .single_product:not(.template)').each( function(){
      
      var h2 = $(this).find('h2');
      var price = $(this).find('.price');
      
      var contentPrice = price.html();
      var content = h2.html().split(',');
      h2.html( content[0]+content[1] );
      
      if ( content[3] == undefined) content[3] = '';
      price.html( '<span>'+content[2]+','+content[3]+'</span><span>'+contentPrice+'</span>' );
      
     
      
      
      
    });
    
  });
    
 
 
  
});